import React from "react";
import "./App.css";
import Routes from "./Routes";

import { useReservation } from "./context/reservation";
import { createMemoryHistory } from "history";
import AppProviders from "./context/index";
import { Switch, Route, Link } from "react-router-dom";

const token =
  "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiYmUxOGQyZDdlNTA5NGZhYjljYWZmNjRmMmNkNWUzNjUiLCJhY2NvdW50X2lkIjoiN2U2NTAwNjExMjc3NGE2NmJhZmVlMTIyYThjODFmZjkiLCJ1c2VybmFtZSI6Im1hcmlhQGNoZWtpbi5jb20iLCJleHAiOjE2NTUyMzY4ODcsIm93bmVyX2lkIjpudWxsLCJyb2xlIjoiT3duZXIiLCJvcmlnX2lhdCI6MTY1NTIzMzI1OSwicmVzZXJ2YXRpb25faWQiOiI5MGE4MDQyOTg0N2I0MGFiYjI1MjEwMDUwOTU2NzRjNiIsImlzX29jcl9lbmFibGUiOmZhbHNlLCJmYWNlX2V4dCI6ZmFsc2UsIm9jcl92aXoiOmZhbHNlLCJvY3JfYmFyY29kZXMiOmZhbHNlfQ.J-JOjJ56zaxvJleLqOgo2XKuTNLXipBSqQm7SPLjIEE";
const browserHistory = createMemoryHistory();



function App() {
  return (
    <AppProviders browserHistory={browserHistory}>
      <Routes />
    </AppProviders>
  );
}

export default App;
